/**
 * All the major modules are declared here and used in other places in the application.
 *
 */
var fourdotfivedirectives = angular.module('4dot5.directivesModule', ['shared']);